class WindowHelper {

  /**
   * Resizes the canvas to fit a new viewport on the window resize event.
   * @param renderer Three.js render for the main canvas/scene
   * @param camera Three.js camera for the main scene
   */
  onWindowResize(renderer, camera) {
    renderer.setSize(window.innerWidth * 0.9, (window.innerWidth * 0.9) * 0.5625);
    // camera.aspect = window.innerWidth / window.innerHeight;
    camera.aspect = 1.77777777;
    camera.updateProjectionMatrix();
  }
}

export default new WindowHelper();
